import $ from 'jquery';
import Globals from '../helpers/Globals';

const { $body } = Globals;

const Form = {
    init() {
        $body.on('change', '.js-newsletter-check', () => this.handleSubmitButton());
    },

    handleSubmitButton() {
        $('.js-newsletter-submit').toggleClass('disabled');
    },
};

export default Form;
